import { ProductCardSerializer } from "web/types/serializers";

export const ProductCard = {
    id: 67751365,
    uid: "JLGQZTQ",
    link_id: 31853126,
    has_variant: false,
    url: "/clothing/alberta-ferretti-long-dress-military-green-1/",
    use_variant: false,
    slug: "alberta-ferretti-long-dress-military-green-1",
    gender: "F",
    short_description: "Long Dress - Green",
    lead_url: "/track/lead/31853126/",
    full_price_with_currency_symbol: "$4,363",
    sale_price_with_currency_symbol: "$1,047",
    currency: "USD",
    designer_name: "Alberta Ferretti",
    designer_slug: "alberta-ferretti",
    retailer_name: "YOOX",
    retailer_slug: "YOOX",
    image_url: null, // overriden in ProductCardFactory
    image_alt_text: "Alberta Ferretti Long Dress - Green",
    icon_enabled: false,
    is_affiliate: true,
    discount_info: "(75% off)",
    sale_discount: 75,
    in_stock: true,
    overlay_enabled: false,
    lead_enabled: true,
    context_type: "related-product",
    show_offer_meta: true,
    free_shipping: false,
    show_retailer_as_affiliate: true,
    description: null,
    sale_badge: null,
    use_lazy_images: true,
    exclusive_badge: null,
    free_shipping_badge: null,
    view_more_url: "/shop/related/alberta-ferretti-long-dress-military-green-1/",
    excluded_from_app: false,
    app_deeplink_path: "/clothing/alberta-ferretti-long-dress-military-green-1/",
    is_saved_for_later: false,
} as ProductCardSerializer;

export function ProductCardFactory(
    productCard: Partial<ProductCardSerializer> = {}
): ProductCardSerializer {
    // keep these unique
    const imageUrl = `https://cdna.lystit.com/200/250/tr/photos/yoox/56dbdced/dress-${productCard.id}.jpeg`;
    return { ...ProductCard, image_url: imageUrl, ...productCard };
}
